import ConditionalCard from 'Components/Reusable/Cards/ConditionalCard';
import React, { Fragment } from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import { Routes } from 'Utils';

interface EmailSentProps extends RouteComponentProps {
	email?: string | undefined;
}
const EmailSent = ({ email, history }: EmailSentProps) => {
	const text = `PLEASE NOTE: 
	\n If you do not receive your email immediately check your Promotions, Junk or Spam folders. \n Make sure you add info@fledglingsflight.com to your contact list. \n If you cannot find your activation email kindly contact us through chat or email us at: info@fledglingsflight.com`
	return (
		<Fragment>
			<ConditionalCard
				information={`${text}`}


				heading={`Check your email to activate your account`}
				conditions={[
					{
						id: 1,
						name: 'Login',
					},
				]}
				common = {{background:'#d4d4d4'}}
				onClick={() => history.push(Routes.Login)}
			/>
		</Fragment>
	);
};

export default withRouter(EmailSent);
